export interface StatCardItem {
  label: string;
  value: string | number;
  variant?: "indigo" | "teal" | "slate" | "amber";
}

/**
 * A row of colored summary cards, meant to sit above a table on list pages
 * to give an at-a-glance overview instead of dropping straight into a bare table.
 */
export default function StatCards({ items }: { items: StatCardItem[] }) {
  return (
    <div className="stat-cards">
      {items.map((item, idx) => (
        <div key={idx} className={`stat-card brand-${item.variant ?? "indigo"}`}>
          <span className="stat-value">{item.value}</span>
          <span className="stat-label">{item.label}</span>
        </div>
      ))}
    </div>
  );
}
